import React from 'react';
import './header.less';
import logo from '@/assets/imgs/walmart.png';
import user from '@/assets/imgs/user.png';
import line from '@/assets/imgs/line.png';
import { formatDate, getWeekday } from '@/utils';
import { CaretDownSmallIcon } from 'tdesign-icons-react';
import { Dropdown, DropdownOption } from 'tdesign-react';
import { useGlobalStore } from '@/stores/context';
import { useNavigate } from 'react-router-dom';
import { PageStatus } from '@/stores/provider';
import { authLoginOut } from '@/api';

type MyHeaderProps = {
  pageTitle: string;
};
const MyHeader: React.FC<MyHeaderProps> = (props) => {
  const { pageTitle } = props;
  const {
    dispatch,
  } = useGlobalStore();
  const navigate = useNavigate();

  const handleClick = async (v: DropdownOption) => {
    if (v.value === 1) {
      try {
        const res = await authLoginOut();
        if (res.code === 0) {
          // 处理退出登录逻辑
          sessionStorage.removeItem('videoAudit-b-token');
          sessionStorage.removeItem('videoAudit-b-userInfo');
          sessionStorage.removeItem('videoAudit-b-pageStatus');
          dispatch({
            type: 'setData',
            data: {
              pageStatus: PageStatus.NOLOGIN,
            }
          });
          navigate('/login', { replace: true });
        }
      } catch (error) {
        console.log(6666, error)
      }
    }
  };
  return (
    <div className="my-header">
      <div className="my-header-left">
        <img src={logo} alt="logo" />
      </div>
      <div className="my-header-right">
        <div className="my-header-right-tiile">{pageTitle}</div>
        <div className="my-header-right-mes">
          <div className="my-header-right-mes-item">
            {formatDate(new Date(), 'YYYY年MM月DD日')}
          </div>
          <div className="my-header-right-mes-item">
            {getWeekday()}
          </div>
          <div className="my-header-right-mes-item">
            <Dropdown
              direction="right"
              hideAfterItemClick
              options={[
                {
                  content: '退出登录',
                  value: 1
                },
              ]}
              placement="bottom-left"
              trigger="hover"
              onClick={handleClick}
            >
              <div className='my-header-right-mes-item-dropdown'>
                <img src={user} alt="user" width={40} />
                {/* <div>名字</div> */}
                <CaretDownSmallIcon />
                <img src={line} width={20}></img>
              </div>
            </Dropdown>
          </div>
        </div>

      </div>
    </div>
  );
};

export default MyHeader;
